// src/context/SettingsContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  function setFavicon(url) {
    if (!url) return;

    let link = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = url;
  }

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${window.BASE_API_URL}settings`);
        
        const data = res.data.data;

        // store currency
        localStorage.setItem("currency_name", data.currency_name);
        localStorage.setItem("currency", data.currency_symbol);

        // store settings in context
        setSettings(data);

        // 🔥 update favicon from settings
        if (data.logo) {
          setFavicon(data.logo);
        }
      } catch (err) {
        console.error("Error fetching settings:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
